/**
 * This file was auto-generated by Fern from our API Definition.
 */
export class FlatfileTimeoutError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, FlatfileTimeoutError.prototype);
    }
}
